'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper function to trigger SegmentIO function to track sign in from barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierSignIn() {
  return (0, _track2.default)(_events.EVENT_BARRIER_SIGN_IN);
}

exports.default = trackBarrierSignIn;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/trackBarrierSignIn.js
// module id = 1625
// module chunks = 1